/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/dome_mobility': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M17.414 19.338L17.078 19H16.414v-1.82c-.609.188-1.5.107-2-.08V19h-.647l-.354.354-1.644 1.645a.5.5 0 000 .708l1.592 1.591.707-.707-1.238-1.236L14.182 20h2.479L18 21.352l-1.229 1.238.711.704 1.578-1.592a.504.504 0 000-.704l-1.646-1.66zM15.727 16.688c.768 0 1.535-.292 2.121-.878l4.229-4.229a8.016 8.016 0 00-5.065-3.419l-3.405 3.406a2.998 2.998 0 002.12 5.12zM15.414 13a1 1 0 110 2 1 1 0 010-2z"/><path pid="1" d="M27.164 12.336V4.25h-8.086L15.414.586 11.75 4.25H3.664v8.086L0 16l3.664 3.664v8.086h8.086l3.664 3.664 3.664-3.664h8.086v-8.086L30.828 16l-3.664-3.664zm-.5-7.586v7.086L19.578 4.75h7.086zm-22.5 0h7.086l-7.086 7.086V4.75zm0 22.5v-7.086l7.086 7.086H4.164zm22.5 0h-7.086l7.086-7.086v7.086zm-11.25 1.336L2.828 16 15.414 3.414 28 16 15.414 28.586z"/>'
  }
})
